import * as ActionTypes from '../actions/index';
import {LOGOUT} from '../actions';
import _ from 'lodash';
import {LOCATION_CHANGE} from 'connected-react-router';
import moment from 'moment';

const quoteStatusToStepMapping = {
  ClientDetails: 1,
  QuoteDetails: 2,
  ViewQuotes: 3,
  HoldCover: 4,
};

const defaultState = {
  wizardStep: 0,
  quoteQuestions: [],
  fetchingQuoteQuestions: false,
  quoteStatuses: [],
  fetchingQuoteStatuses: false,
  quoteIPT: {},
  fetchingQuoteIPT: false,
  quoteMessages: [],
  fetchingQuoteMessages: false,
  clientDetailsForm: {},
  agentCommission: '17.5',
  posting: false,
  postingErrorMessage: '',
  agreeToHoldCover: false,
  clientAddress: '',
  coverStartDate: '',
  quoteRequired: '',
  updating: false,
  updateErrorMessage: '',
  errorMessage: '',
  quote: {},
  products: {},
  quotePolicyOverview: [],
  fetchingQuotePolicyOverview: false,
  fetchingQuote: false,
  quoteDefaultSettings: [],
  quoteScheduleMessage: [],
  broker: '',
  quoteProposalForm: {},
  fetchingQuoteProposalForm: false,
  sendingQuoteScheduleViaEmail: false,
  sendEmailSuccessResponse: '',
  sendEmailFailResponse: '',
  minimumPricings: [],
  fetchingQuotePolicyWording: false,
  quotePolicyWording: {},
  fetchingQuotePointOfSale: false,
  quotePointOfSale: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.GET_QUOTE_MINIMUM_PRICING:
      return {
        ...state,
      };
    case ActionTypes.GET_QUOTE_MINIMUM_PRICING_SUCCESS:
      var pricings = [];
      try {
        pricings = action.payload.body;
      } catch (e) {
        pricings = [];
      }
      return {
        ...state,
        minimumPricings: pricings,
      };
    case ActionTypes.GET_QUOTE_MINIMUM_PRICING_FAILED:
      return {
        ...state,
      };
    case ActionTypes.GET_QUOTE_SCHEDULE_INFO:
      return {
        ...state,
      };
    case ActionTypes.GET_QUOTE_SCHEDULE_INFO_SUCCESS:
      return {
        ...state,
      };
    case ActionTypes.GET_QUOTE_SCHEDULE_INFO_FAILED:
      return {
        ...state,
      };
    case ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL:
      return {
        ...state,
        sendingQuoteScheduleViaEmail: true,
        sendEmailSuccessResponse: defaultState.sendEmailSuccessResponse,
        sendEmailFailResponse: defaultState.sendEmailFailResponse,
      };
    case ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL_SUCCESS:
      return {
        ...state,
        sendingQuoteScheduleViaEmail: false,
        sendEmailSuccessResponse: 'Email sent',
      };
    case ActionTypes.SEND_QUOTE_SCHEDULE_VIA_EMAIL_FAILED:
      let emailFailRes = '';
      try {
        emailFailRes = action.payload.response.body.message;
      } catch (e) {
        emailFailRes = 'Failed to send email';
      }
      return {
        ...state,
        sendingQuoteScheduleViaEmail: false,
        sendEmailFailResponse: emailFailRes,
      };
    case ActionTypes.GET_QUOTE_PROPOSAL_FORMS:
      return {
        ...state,
        fetchingQuoteProposalForm: true,
      };
    case ActionTypes.GET_QUOTE_PROPOSAL_FORMS_SUCCESS:
      return {
        ...state,
        fetchingQuoteProposalForm: false,
        quoteProposalForm: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_PROPOSAL_FORMS_FAILED:
      return {
        ...state,
        fetchingQuoteProposalForm: false,
      };
    case ActionTypes.GET_QUOTE_POLICY_WORDINGS:
      return {
        ...state,
        fetchingQuotePolicyWording: true,
      };
    case ActionTypes.GET_QUOTE_POLICY_WORDINGS_SUCCESS:
      return {
        ...state,
        fetchingQuotePolicyWording: false,
        quotePolicyWording: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_POLICY_WORDINGS_FAILED:
      return {
        ...state,
        fetchingQuotePolicyWording: false,
      };
    case ActionTypes.GET_QUOTE_POINTS_OF_SALE:
      return {
        ...state,
        fetchingQuotePointOfSale: true,
      };
    case ActionTypes.GET_QUOTE_POINTS_OF_SALE_SUCCESS:
      return {
        ...state,
        fetchingQuotePointOfSale: false,
        quotePointOfSale: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_POINTS_OF_SALE_FAILED:
      return {
        ...state,
        fetchingQuotePointOfSale: false,
      };
    case ActionTypes.RESET_QUOTE_STATE:
      return defaultState;
    case ActionTypes.GET_QUOTE_SCHEDULES_MESSAGE_SUCCESS:
      return {
        ...state,
        quoteScheduleMessage: action.payload.body,
      };
    case ActionTypes.RESET_QUOTE_OPTIONS:
      return {
        ...state,
        agentCommission: defaultState.agentCommission,
      };
    case ActionTypes.GET_QUOTE_BY_ID:
      return {
        ...state,
        fetchingQuote: true,
      };
    case ActionTypes.GET_QUOTE_BY_ID_SUCCESS:
      if (!action.payload.body) {
        return state;
      }
      const fetchedGrouped = _.groupBy(
        action.payload.body.availableProducts,
        'masterProductId',
      );
      const fetchedProducts = _.mapValues(fetchedGrouped, (group, index) => {
        let name;
        try {
          name = group[0].masterProductName;
        } catch (e) {
          name = '';
        }
        return {
          masterProductId: index,
          masterProductName: name,
          limitOfIndemnity: state.products[index]
            ? state.products[index].limitOfIndemnity
            : '',
          commercialRates: group,
        };
      });
      const answerClientDetails = {...state.clientDetailsForm};
      _.forEach(action.payload.body.applicationAnswersDtos, dto => {
        if (dto.optionId) {
          answerClientDetails[dto.questionId] = dto.optionId;
        }
        if (dto.amount) {
          answerClientDetails[dto.questionId] = dto.amount;
        }
        if (dto.text) {
          answerClientDetails[dto.questionId] = dto.text;
        }
        if (dto.date) {
          answerClientDetails[dto.questionId] = moment(dto.date).format(
            'DD/MM/YYYY',
          );
        }
      });
      return {
        ...state,
        fetchingQuote: false,
        wizardStep:
          quoteStatusToStepMapping[action.payload.body.statusMachineName],
        quote: action.payload.body,
        products: fetchedProducts,
        clientDetailsForm: answerClientDetails,
      };
    case ActionTypes.GET_QUOTE_BY_ID_FAILED:
      return {
        ...state,
        fetchingQuote: false,
      };
    case ActionTypes.GET_QUOTE_POLICY_OVERVIEW:
      return {
        ...state,
        fetchingQuotePolicyOverview: true,
      };
    case ActionTypes.GET_QUOTE_POLICY_OVERVIEW_SUCCESS:
      return {
        ...state,
        fetchingQuotePolicyOverview: false,
        quotePolicyOverview: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_POLICY_OVERVIEW_FAILED:
      return {
        ...state,
        fetchingQuotePolicyOverview: false,
      };
    case ActionTypes.COPY_QUOTE:
      return {
        ...defaultState,
        clientDetailsForm: state.clientDetailsForm,
      };
    case ActionTypes.GET_QUOTE_DEFAULT_SETTINGS_SUCCESS:
      const selectedProducts = {...state.products};
      try {
        _.forEach(action.payload.body, (setting, index) => {
          if (selectedProducts[setting.productId]['limitOfIndemnity']) {
            return true;
          }
          const product = _.find(state.quote.availableProducts, product => {
            return (
              product.masterProductId === setting.productId &&
              product.limitOfIndemnity.toString() ===
                setting.limitOfIndemnity.toString()
            );
          });
          selectedProducts[setting.productId]['limitOfIndemnity'] =
            product.limitOfIndemnity.toString();
        });
      } catch (e) {
        return state;
      }
      return {
        ...state,
        products: selectedProducts,
        quoteDefaultSettings: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_MESSAGES:
      return {
        ...state,
        fetchingQuoteMessages: true,
      };
    case ActionTypes.GET_QUOTE_MESSAGES_SUCCESS:
      return {
        ...state,
        quoteMessages: action.payload.body,
        fetchingQuoteMessages: false,
      };
    case ActionTypes.GET_QUOTE_MESSAGES_FAILED:
      return {
        ...state,
        fetchingQuoteMessages: false,
      };
    case ActionTypes.GET_QUOTE_IPT:
      return {
        ...state,
        fetchingQuoteIPT: true,
      };
    case ActionTypes.GET_QUOTE_IPT_SUCCESS:
      return {
        ...state,
        quoteIPT: action.payload.body,
        fetchingQuoteIPT: false,
      };
    case ActionTypes.GET_QUOTE_IPT_FAILED:
      return {
        ...state,
        fetchingQuoteIPT: false,
      };
    case ActionTypes.HANDLE_QUOTE_PRODUCTS_CHANGE:
      return {
        ...state,
        products: {
          ...state.products,
          [action.payload.key]: {
            ...state.products[action.payload.key],
            limitOfIndemnity: action.payload.value,
          },
        },
      };
    case ActionTypes.UPDATE_QUOTE:
      return {
        ...state,
        updating: true,
        updateErrorMessage: defaultState.updateErrorMessage,
        errorMessage: defaultState.errorMessage,
        sendEmailSuccessResponse: defaultState.sendEmailSuccessResponse,
        sendEmailFailResponse: defaultState.sendEmailFailResponse,
      };
    case ActionTypes.UPDATE_QUOTE_SUCCESS:
      return {
        ...state,
        updating: false,
        quote: action.payload.body,
        wizardStep: state.wizardStep + 1,
      };
    case ActionTypes.UPDATE_QUOTE_FAILED:
      let updateErrorMsg = '';
      try {
        updateErrorMsg = action.payload.response.body.message;
      } catch (e) {
        updateErrorMsg = 'Failed to update quote';
      }
      return {
        ...state,
        updating: false,
        updateErrorMessage: updateErrorMsg,
      };
    case ActionTypes.CHANGE_QUOTE_REQUIRED:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case ActionTypes.CHANGE_BROKER_COMMISSION:
      return {
        ...state,
        agentCommission: action.payload.value,
      };
    case ActionTypes.CREATE_QUOTE:
      return {
        ...state,
        posting: true,
        postingErrorMessage: defaultState.postingErrorMessage,
      };
    case ActionTypes.CREATE_QUOTE_SUCCESS:
      if (!action.payload.body) {
        return state;
      }
      const grouped = _.groupBy(
        action.payload.body.availableProducts,
        'masterProductId',
      );
      const products = _.mapValues(grouped, (group, index) => {
        let name;
        try {
          name = group[0].masterProductName;
        } catch (e) {
          name = '';
        }
        return {
          masterProductId: index,
          masterProductName: name,
          limitOfIndemnity: state.products[index]
            ? state.products[index].limitOfIndemnity
            : '',
          commercialRates: group,
        };
      });
      return {
        ...state,
        posting: false,
        wizardStep: state.wizardStep === 0 ? 1 : state.wizardStep,
        quote: action.payload.body,
        products: products,
      };
    case ActionTypes.CREATE_QUOTE_FAILED:
      let postFailMessage = '';
      try {
        postFailMessage = action.payload.response.body.message;
      } catch (e) {
        postFailMessage = 'Failed to create quote';
      }
      return {
        ...state,
        posting: false,
        postingErrorMessage: postFailMessage,
      };
    case ActionTypes.CHANGE_QUOTE_CLIENT_DETAILS_FORM:
      return {
        ...state,
        clientDetailsForm: {
          ...state.clientDetailsForm,
          [action.payload.key]: action.payload.value,
        },
        postingErrorMessage: defaultState.postingErrorMessage,
      };
    case ActionTypes.GET_QUOTE_STATUSES:
      return {
        ...state,
        fetchingQuoteStatuses: true,
      };
    case ActionTypes.GET_QUOTE_STATUSES_SUCCESS:
      return {
        ...state,
        fetchingQuoteStatuses: false,
        quoteStatuses: action.payload.body,
      };
    case ActionTypes.GET_QUOTE_STATUSES_FAILED:
      return {
        ...state,
        fetchingQuoteStatuses: false,
      };
    case ActionTypes.GET_QUOTE_QUESTIONS:
      return {
        ...state,
        fetchingQuoteQuestions: true,
      };
    case ActionTypes.GET_QUOTE_QUESTIONS_SUCCESS:
      let formData = _.mapValues(_.keyBy(action.payload.body, 'id'), (i, key) =>
        state.clientDetailsForm[key] ? state.clientDetailsForm[key] : '',
      );
      return {
        ...state,
        fetchingQuoteQuestions: false,
        quoteQuestions: action.payload.body,
        clientDetailsForm: formData,
      };
    case ActionTypes.GET_QUOTE_QUESTIONS_FAILED:
      return {
        ...state,
        fetchingQuoteQuestions: false,
      };
    case ActionTypes.CHANGE_QUOTE_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case LOGOUT:
      return {
        ...defaultState,
      };
    case LOCATION_CHANGE:
      if (action.payload.location.pathname === '/quote') {
        return state;
      }
      return {
        ...defaultState,
        quoteStatuses: state.quoteStatuses,
      };
    default:
      return state;
  }
};
